import React, { useState } from 'react';
import { Hash, Send, Paperclip, Smile, MoreVertical, Search } from 'lucide-react';
export function ChatPage() {
  const [activeChannel, setActiveChannel] = useState('general');
  const [messageInput, setMessageInput] = useState('');
  const channels = [{
    id: 'general',
    name: 'general',
    unread: 0
  }, {
    id: 'wins',
    name: 'wins-milestones',
    unread: 3
  }, {
    id: 'help',
    name: 'ask-for-help',
    unread: 0
  }, {
    id: 'resources',
    name: 'resources',
    unread: 1
  }, {
    id: 'fundraising',
    name: 'fundraising',
    unread: 0
  }];
  const messages = [{
    id: 1,
    user: 'Marcus Johnson',
    initials: 'MJ',
    color: 'bg-catalyst-mustard-dark',
    time: '10:23 AM',
    text: 'Has anyone here successfully navigated the SR&ED tax credit application process? Looking for some tips before we submit next week.'
  }, {
    id: 2,
    user: 'Sarah Jenkins',
    initials: 'SJ',
    color: 'bg-blue-600',
    time: '10:45 AM',
    text: 'Yes! We did it last year. The key is making sure your technical narratives clearly define the technological uncertainty. Happy to share our redacted narrative if it helps.'
  }, {
    id: 3,
    user: 'Marcus Johnson',
    initials: 'MJ',
    color: 'bg-catalyst-mustard-dark',
    time: '10:48 AM',
    text: "That would be incredible Sarah, thank you! I'll DM you."
  }, {
    id: 4,
    user: 'Dr. Marcus Chen',
    initials: 'MC',
    color: 'bg-catalyst-brown-light',
    time: '11:15 AM',
    text: "Just a reminder to everyone that we have a workshop specifically on non-dilutive funding (including SR&ED) next Thursday. I've uploaded the prep materials to the resources channel.",
    isAdvisor: true
  }, {
    id: 5,
    user: 'Amara Diallo',
    initials: 'AD',
    color: 'bg-purple-600',
    time: '11:30 AM',
    text: 'Thanks Dr. Chen, looking forward to it. The templates from last week were super helpful.'
  }];
  return <div className="h-[calc(100vh-8rem)] flex flex-col animate-in fade-in duration-500" data-id="element-291">
      <div className="mb-6" data-id="element-292">
        <h1 className="text-3xl font-heading font-bold text-catalyst-black tracking-tight" data-id="element-293">
          Community Chat
        </h1>
        <p className="text-gray-500 mt-1" data-id="element-294">
          Real-time discussions with your cohort and advisors
        </p>
      </div>

      <div className="flex-1 bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex" data-id="element-295">
        {/* Sidebar */}
        <div className="w-64 border-r border-gray-200 bg-gray-50 flex flex-col shrink-0" data-id="element-296">
          <div className="p-4 border-b border-gray-200" data-id="element-297">
            <div className="relative" data-id="element-298">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} data-id="element-299" />
              <input type="text" placeholder="Jump to..." className="w-full pl-8 pr-3 py-1.5 bg-white border border-gray-200 rounded-md text-sm focus:outline-none focus:border-catalyst-mustard" data-id="element-300" />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto py-4" data-id="element-301">
            <div className="px-4 mb-2" data-id="element-302">
              <h2 className="text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-303">
                Channels
              </h2>
            </div>
            <div className="space-y-0.5" data-id="element-304">
              {channels.map(channel => <button key={channel.id} onClick={() => setActiveChannel(channel.id)} className={`w-full flex items-center justify-between px-4 py-2 text-sm transition-colors ${activeChannel === channel.id ? 'bg-catalyst-mustard/10 text-catalyst-mustard-dark font-medium border-r-2 border-catalyst-mustard' : 'text-gray-600 hover:bg-gray-100 border-r-2 border-transparent'}`} data-id="element-305">
                  <div className="flex items-center gap-2" data-id="element-306">
                    <Hash size={16} className={activeChannel === channel.id ? 'text-catalyst-mustard' : 'text-gray-400'} data-id="element-307" />
                    <span data-id="element-308">{channel.name}</span>
                  </div>
                  {channel.unread > 0 && <span className="bg-catalyst-black text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full" data-id="element-309">
                      {channel.unread}
                    </span>}
                </button>)}
            </div>
          </div>
        </div>

        {/* Main Chat Area */}
        <div className="flex-1 flex flex-col min-w-0" data-id="element-310">
          {/* Chat Header */}
          <div className="h-14 border-b border-gray-200 px-6 flex items-center justify-between bg-white shrink-0" data-id="element-311">
            <div className="flex items-center gap-2" data-id="element-312">
              <Hash size={20} className="text-gray-400" data-id="element-313" />
              <h2 className="font-bold text-catalyst-black" data-id="element-314">
                {channels.find(c => c.id === activeChannel)?.name}
              </h2>
            </div>
            <div className="flex items-center gap-3 text-gray-500" data-id="element-315">
              <button className="hover:text-catalyst-black transition-colors" data-id="element-316">
                <Search size={18} data-id="element-317" />
              </button>
              <button className="hover:text-catalyst-black transition-colors" data-id="element-318">
                <MoreVertical size={18} data-id="element-319" />
              </button>
            </div>
          </div>

          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-6 space-y-6 bg-white" data-id="element-320">
            <div className="text-center mb-8" data-id="element-321">
              <span className="text-xs font-medium text-gray-400 bg-gray-50 px-3 py-1 rounded-full border border-gray-100" data-id="element-322">
                Today, March 20th
              </span>
            </div>

            {messages.map(msg => <div key={msg.id} className="flex gap-4 group" data-id="element-323">
                <div className={`w-10 h-10 rounded-full ${msg.color} flex items-center justify-center text-white font-bold text-sm shrink-0 shadow-sm`} data-id="element-324">
                  {msg.initials}
                </div>
                <div data-id="element-325">
                  <div className="flex items-baseline gap-2 mb-1" data-id="element-326">
                    <span className="font-bold text-catalyst-black" data-id="element-327">
                      {msg.user}
                    </span>
                    {msg.isAdvisor && <span className="text-[10px] font-bold uppercase tracking-wider bg-catalyst-brown/10 text-catalyst-brown-dark px-1.5 py-0.5 rounded" data-id="element-328">
                        Advisor
                      </span>}
                    <span className="text-xs text-gray-400" data-id="element-329">{msg.time}</span>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed" data-id="element-330">
                    {msg.text}
                  </p>
                </div>
              </div>)}
          </div>

          {/* Input Area */}
          <div className="p-4 bg-white border-t border-gray-200 shrink-0" data-id="element-331">
            <div className="border border-gray-300 rounded-xl overflow-hidden focus-within:border-catalyst-mustard focus-within:ring-1 focus-within:ring-catalyst-mustard transition-all shadow-sm" data-id="element-332">
              <textarea value={messageInput} onChange={e => setMessageInput(e.target.value)} placeholder={`Message #${channels.find(c => c.id === activeChannel)?.name}`} className="w-full max-h-32 min-h-[80px] p-3 resize-none focus:outline-none text-sm" data-id="element-333" />
              <div className="bg-gray-50 px-3 py-2 flex justify-between items-center border-t border-gray-200" data-id="element-334">
                <div className="flex gap-2 text-gray-400" data-id="element-335">
                  <button className="p-1.5 hover:text-catalyst-black hover:bg-gray-200 rounded transition-colors" data-id="element-336">
                    <Paperclip size={18} data-id="element-337" />
                  </button>
                  <button className="p-1.5 hover:text-catalyst-black hover:bg-gray-200 rounded transition-colors" data-id="element-338">
                    <Smile size={18} data-id="element-339" />
                  </button>
                </div>
                <button className="bg-catalyst-mustard text-catalyst-black px-4 py-1.5 rounded-lg text-sm font-semibold hover:bg-catalyst-mustard-light transition-colors flex items-center gap-2 shadow-sm" data-id="element-340">
                  Send <Send size={14} data-id="element-341" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}